import { useProduct } from '@/components/product/product-context';
import offsetBlockClass from '@/utils/offsetBlockClass';
import { findSelectorOption, readSelectorSettings } from '../selector-settings';
import RadioSelector from './RadioSelector';
import CheckboxSelector from './CheckboxSelector';

/**
 * This component allows for two styles of variant selectors meant for showcasing
 * upgrades.
 *
 * - Checkbox: A single checkbox that shows a single upgrade option.
 * - Radio: A radio selector that shows two or more upgrades plus the base option.
 *
 * Fully static: the section always renders when the option exists on the
 * product, so the selectors own the Suspense boundaries for the selection.
 */
export default function ColumnSelector({ block, position }) {
  const { productData } = useProduct();
  const { settings, selectorSettings } = readSelectorSettings(block);
  const { uid, option: optionName, show_offset_block_selector } = settings;

  if (!findSelectorOption(productData, optionName, 'column selector')) {
    return null;
  }

  const Selector =
    selectorSettings.input_type === 'Checkbox'
      ? CheckboxSelector
      : RadioSelector;

  return (
    <section
      id={`${uid ?? 'variant-selector'}_${position}`}
      data-name="variant-selector"
      className={offsetBlockClass(show_offset_block_selector, 'not-last:mb-8')}
    >
      <Selector settings={settings} />
    </section>
  );
}
